import React, { Component, ChangeEvent } from "react";
import "./ForgotPassword.css";
import { Alert, Snackbar, Box } from '@mui/material';
import { resetPassword } from '../Components/ApiSevices/AuthApis'
import BackgroundCarousel from "./BackgroundCarousel";

interface State {
    email: string;
    submitted: boolean;
    loading: boolean;
    showError: boolean;
    touched: boolean;
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
}

class ForgotPassword extends Component<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {
            email: "",
            submitted: false,
            loading: false,
            showError: false,
            touched: false,
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
        };
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({ email: e.target.value });
    };

    handleBlur = () => {
        this.setState({ touched: true }, this.validate);
    };

    validate = () => {
        const { email, touched } = this.state;
        this.setState({ showError: touched && !email });
    };

    handleSubmit = async () => {
        const { email } = this.state;
        if (!email) {
            this.setState({ showError: true, loading : false });
            return;
        }

        this.setState({ loading: true, showError: false });
        
        try {
            const response = await resetPassword({ UserName: email });
            this.showSnackbar(response?.message, 'success');
            this.setState({ submitted: true, showError: false });
        } catch (error: any) {
            console.error("Error:", error);
            if (error?.status == 404) {
                this.showSnackbar(error?.response?.data?.detail, 'error');
            }
            this.setState({ showError: true });
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { email, submitted, showError, snackbarOpen, snackbarMessage, snackbarSeverity, loading } = this.state;
        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <div className="forgot-container">
                    <BackgroundCarousel />
                    <div className="overlay">
                        <div className="forgot-box">
                            <img src="/exdionedge.jpg" alt="Exdionedge" className="logo" />
                            {!submitted ? (
                                <>
                                    <input
                                        type="text"
                                        placeholder="Username"
                                        value={email}
                                        onChange={this.handleChange}
                                        onBlur={this.handleBlur}
                                    />
                                    {showError && !email && (
                                        <p className="error-msg" style={{textAlign:"left"}}>UserEmail is required</p>
                                    )}

                                    <button className="reset-button" onClick={this.handleSubmit}>
                                        Reset
                                    </button>
                                </>
                            ) : (
                                <p style={{ color: "Red" }}>
                                    Password reset link has been sent to your registered email. Please use the link to reset the password.
                                </p>
                            )}
                            <div className="footer-banner">
                                <img src="/Banner.png" alt="Banner" width="100%" />
                            </div>
                        </div>
                    </div>
                </div>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}

export default ForgotPassword;
